export const NAV_ITEM_ID_CREATE_COMPANY = 'create-company'
